// extracted by mini-css-extract-plugin
export default {"title":"VcKFHGEZnA1B32tINeiY","titleText":"JPvwJamzaN52CsELJkl2","name":"FrpcdwbnkxgOBWmfiiI5","container":"x_4kNa3eVTXpidhYoRq3","nameText":"v9EyF9knSNvLrC69JTzV"};